export const BN = {
    translations: {
        notifications: 'নোটিফিকেশন',
        markAllAsRead: 'সবগুলো পড়া হয়েছে',
        poweredBy: 'পাওয়ার্ড বাই',
        settings: 'সেটিংস',
        noNewNotification: 'এখানে এখনো নতুন কিছু দেখার নেই',
    },
    lang: 'bn',
};
//# sourceMappingURL=bn.js.map